import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Trans, useTranslation } from 'react-i18next'

import classes from './PrivacyTermsFooter.module.scss'

const PrivacyTermsFooter = ({ className }) => {
  const { t } = useTranslation()

  return (
    <footer className={classNames(classes.privacyTermsFooter, 'w-100', className)}>
      <p className={classes.footerText}>
        <Trans
          i18nKey='auth.privacyTermsFooter.agreement'
          components={{
            privacyLink: (
              <a href='https://operation36.golf/legal/privacy/' target='_blank' rel='noreferrer' className={classes.footerLink}>
                {t('common.legal.privacyPolicy')}
              </a>
            ),
            termsLink: (
              <a href='https://operation36.golf/legal/terms/' target='_blank' rel='noreferrer' className={classes.footerLink}>
                {t('auth.privacyTermsFooter.termsAndConditions')}
              </a>
            ),
          }}
        >
          By continuing you confirm that you have read and agreed to the <privacyLink /> and <termsLink />
        </Trans>
      </p>
    </footer>
  )
}

PrivacyTermsFooter.propTypes = {
  className: PropTypes.string,
}

export default PrivacyTermsFooter
